import { render } from "./sprayingController.vue?vue&type=template&id=94970664&scoped=true"
import script from "./sprayingController.vue?vue&type=script&lang=js"
export * from "./sprayingController.vue?vue&type=script&lang=js"

import "./sprayingController.vue?vue&type=style&index=0&id=94970664&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94970664"]])

export default __exports__